<app-header [forceLightBackground]="true"></app-header>
<div class="admin-manage-feedback">
  <div class="admin-manage-feedback--layout">
    <app-admin-sidebar class="admin-manage-feedback--sidebar"></app-admin-sidebar>
    <div class="admin-manage-feedback--content">
      <app-page-header></app-page-header>
      <div class="manage-feedback-container">
        <app-filter-panel
          [fields]="filterFields"
          [defaultExpanded]="false"
          (filterChange)="onFilterChange($event)"
          (clearFilters)="onClearFilters()"
        ></app-filter-panel>

        <app-table
          [columns]="columns"
          [data]="rows"
          [dropdownOpenRowIndex]="openDropdownRowIndex"
          [scrollable]="true"
          [scrollHeight]="'none'"
          [loading]="loading"
          [pagination]="pagination"
          [emptyMessage]="emptyMessage"
          [striped]="true"
          [bordered]="true"
          [hoverable]="true"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
        >
          <ng-template #feedbackCell let-row>
            <span
              *ngIf="hasFeedbackText(row); else emptyFeedback"
              class="feedback-text feedback-text--clickable"
              (click)="openFeedbackModal(row, $event)"
            >{{ row.userFeedback }}</span>
            <ng-template #emptyFeedback>
              <span class="feedback-text feedback-text--empty">—</span>
            </ng-template>
          </ng-template>

          <ng-template #ratingCell let-row>
            <div
              class="rating-stars"
              *ngIf="ratingValue(row) > 0; else emptyRating"
              [attr.aria-label]="'Rating ' + ratingValue(row) + ' out of 5'"
            >
              <img
                *ngFor="let star of [1, 2, 3, 4, 5]"
                class="rating-stars__icon"
                [src]="
                  isStarFilled(row, star)
                    ? 'icons/dataset-ratings/star-filled.svg'
                    : 'icons/dataset-ratings/star-outline.svg'
                "
                alt=""
                width="16"
                height="16"
              />
            </div>
            <ng-template #emptyRating>
              <span class="rating-value rating-value--empty">—</span>
            </ng-template>
          </ng-template>

          <ng-template #statusCell let-row>
            <span [ngClass]="statusChipClass(row.status)">{{ statusLabel(row.status) }}</span>
          </ng-template>

          <ng-template #actionCell let-row let-rowIndex="rowIndex">
            <div class="action-cell-wrapper">
              <button
                type="button"
                class="action-btn"
                (click)="toggleActionDropdown($event, rowIndex)"
                [class.active]="isDropdownOpen(rowIndex)"
              >
                <span>Action</span>
              </button>
            </div>
          </ng-template>
        </app-table>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="dropdownPosition && openDropdownRow"
  class="action-dropdown-overlay"
  [style.top.px]="dropdownPosition.top"
  [style.left.px]="dropdownPosition.left"
  [style.right.px]="dropdownPosition.right"
  (click)="$event.stopPropagation()"
>
  <ul class="dropdown-list">
    <li class="dropdown-item">
      <button
        type="button"
        class="dropdown-link"
        (click)="handleAction('view', openDropdownRow)"
      >
        View Details
      </button>
    </li>
    <li class="dropdown-item">
      <button
        type="button"
        class="dropdown-link"
        [class.disabled]="!canApproveOrReject(openDropdownRow)"
        [disabled]="!canApproveOrReject(openDropdownRow)"
        (click)="canApproveOrReject(openDropdownRow) && handleAction('approve', openDropdownRow)"
      >
        Approve
      </button>
    </li>
    <li class="dropdown-item">
      <button
        type="button"
        class="dropdown-link"
        [class.disabled]="!canApproveOrReject(openDropdownRow)"
        [disabled]="!canApproveOrReject(openDropdownRow)"
        (click)="canApproveOrReject(openDropdownRow) && handleAction('reject', openDropdownRow)"
      >
        Reject
      </button>
    </li>
  </ul>
</div>

<app-modal
  [(visible)]="showFeedbackModal"
  header="User Feedback"
  [width]="'512px'"
  styleClass="custom-modal give-rating-dialog feedback-view-dialog"
  maskStyleClass="feedback-view-mask"
  appendTo="body"
  [showFooter]="false"
  (visibleChange)="onFeedbackModalVisibleChange($event)"
>
  <div class="give-rating" *ngIf="feedbackModalRow as row">
    <div class="feedback-from">
      <span class="feedback-from__avatar" aria-hidden="true">{{ feedbackAuthorInitials(row) }}</span>
      <div class="feedback-from__meta">
        <span class="feedback-from__label">Feedback from</span>
        <span class="feedback-from__name">{{ feedbackAuthorName(row) }}</span>
        <span class="feedback-from__org" *ngIf="feedbackAuthorOrg(row)">{{ feedbackAuthorOrg(row) }}</span>
      </div>
    </div>

    <div class="give-rating--field">
      <label class="give-rating--label" id="view-feedback-stars-label">Rating</label>
      <div
        class="give-rating--stars"
        role="img"
        [attr.aria-label]="'Rating ' + feedbackModalRating + ' out of 5'"
        aria-labelledby="view-feedback-stars-label"
      >
        <span *ngFor="let star of [1, 2, 3, 4, 5]" class="give-rating--star" aria-hidden="true">
          <img
            [src]="
              feedbackModalRating >= star
                ? 'icons/dataset-ratings/star-filled.svg'
                : 'icons/dataset-ratings/star-outline.svg'
            "
            alt=""
            width="40"
            height="40"
          />
        </span>
      </div>
    </div>

    <div class="give-rating--field">
      <label class="give-rating--label">Feedback</label>
      <p
        class="give-rating--feedback-text"
        [class.give-rating--feedback-text-empty]="!hasFeedbackText(row)"
      >
        {{ hasFeedbackText(row) ? row.userFeedback : 'No written feedback' }}
      </p>
    </div>

    <div class="give-rating--field" *ngIf="row.status === 'rejected' && row.rejectionComment">
      <label class="give-rating--label">Comment for rejection</label>
      <p class="give-rating--feedback-text">{{ row.rejectionComment }}</p>
    </div>
  </div>
</app-modal>

<app-confirmation-dialog
  [visible]="isApproveConfirmationVisible"
  (visibleChange)="isApproveConfirmationVisible = $event"
  type="info"
  themeColor="green"
  title="Approve Feedback"
  [message]="getApproveMessage()"
  confirmLabel="Approve"
  cancelLabel="Cancel"
  [loading]="statusActionLoading"
  (onConfirm)="onApproveConfirm()"
  (onCancel)="onApproveCancel()"
  (onClose)="onApproveCancel()"
></app-confirmation-dialog>

<app-modal
  [(visible)]="isRejectConfirmationVisible"
  header="Reject Feedback"
  [width]="'540px'"
  styleClass="custom-modal reject-feedback-dialog"
  maskStyleClass="reject-feedback-mask"
  appendTo="body"
  [showFooter]="false"
  [closable]="!statusActionLoading"
  (visibleChange)="onRejectModalVisibleChange($event)"
>
  <div class="reject-feedback">
    <p class="reject-feedback__message" [innerHTML]="getRejectMessage()"></p>

    <div class="give-rating--field">
      <label class="give-rating--label" for="reject-feedback-reason">
        Reason for rejection <span class="give-rating--required">*</span>
      </label>
      <div class="give-rating--textarea-wrap">
        <textarea
          id="reject-feedback-reason"
          class="give-rating--textarea"
          rows="5"
          [maxlength]="rejectReasonMax"
          placeholder="Enter the reason for rejection..."
          [(ngModel)]="rejectReason"
          [disabled]="statusActionLoading"
          (ngModelChange)="onRejectReasonChange()"
        ></textarea>
        <span class="give-rating--counter">{{ rejectReasonLength }}/{{ rejectReasonMax }}</span>
      </div>
      <p class="give-rating--error" *ngIf="showRejectReasonError">Please enter a reason for rejection</p>
    </div>

    <div class="reject-feedback__actions">
      <button
        type="button"
        class="reject-feedback__cancel"
        [disabled]="statusActionLoading"
        (click)="onRejectCancel()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="reject-feedback__confirm"
        [disabled]="statusActionLoading || !canSubmitReject"
        (click)="onRejectConfirm()"
      >
        {{ statusActionLoading ? 'Rejecting...' : 'Reject' }}
      </button>
    </div>
  </div>
</app-modal>
